
<app-checkbox
*ngIf="params?.data?.type == 'New Record'"
[status]="params.value"
(check)="onSelectChange($event)"
[lableName]="'Import Anyway'"
[lableClass]="'text-light-gray font-16'"
[dyanamicId]="getDynamicId(params)"
>
</app-checkbox>
<!-- [dyanamicId]="params?.data?.companyName + params?.data?.id" -->
<div *ngIf="params?.colDef?.field == 'link'">
    <a class="text-danger hand font-14 text-decoration-underline"  (click)="onClick(params)">Unlink Part</a>
</div>